import { render, staticRenderFns } from "./SchoolResults.vue?vue&type=template&id=42632df3&scoped=true&"
import script from "./SchoolResults.vue?vue&type=script&lang=js&"
export * from "./SchoolResults.vue?vue&type=script&lang=js&"
import style0 from "./SchoolResults.vue?vue&type=style&index=0&id=42632df3&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42632df3",
  null
  
)

export default component.exports